import { withBreakpointRange } from '@optimus-web/core';
import { MatchingFields as MatchingFieldsBase } from './MatchingFields';

export const MatchingFields = withBreakpointRange(MatchingFieldsBase);
export type { MatchingFieldsProps } from './MatchingFields';
